import { render } from "./LogbookForm56Page.vue?vue&type=template&id=d74ecb68"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__